var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05357 5.48212H13.125M3.43452 0.625V2.08231M13.625 0.625V2.08214M13.625 2.08214H3.625C1.96815 2.08214 0.625 3.42528 0.625 5.08214V14.625C0.625 16.2819 1.96815 17.625 3.625 17.625H13.625C15.2819 17.625 16.625 16.2819 16.625 14.625L16.625 5.08213C16.625 3.42528 15.2819 2.08214 13.625 2.08214Z",
    stroke: "#E77B7B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCalendar);
export default __webpack_public_path__ + "static/media/Red_Calendar.790b83885349fa2d346574d4abea2c38.svg";
export { ForwardRef as ReactComponent };